
import { Vue, Component, Prop } from 'vue-property-decorator';
import { HistoryItemType } from '@/features/shipment-history/types';
import { getCarrierLogoCode } from '@/features/common/helpers/carrier';

@Component
export default class Carrier extends Vue {
  @Prop({ required: true }) item!: HistoryItemType;

  private getCarrierLogoCode = getCarrierLogoCode;
}
